import { ROLE_ID_OPERACIONES, ROLE_IDS_MARKETPLACE_STORE_FILTER } from './roleIds'

/** Reexporta el id de rol desde `roleIds.ts` (compatibilidad) */
export {
  ROLE_ID_MANAGER_MARKETPLACE as MANAGER_MARKETPLACE_ROLE_ID,
  ROLE_ID_MARKETPLACE_STORE_FILTER_25,
  ROLE_IDS_MARKETPLACE_STORE_FILTER,
} from './roleIds'

export const MANAGER_MARKETPLACE_STORE_NAMES = [
  'Mercado Libre',
  'Falabella',
  'Exito',
] as const

export const OPERACIONES_STORE_NAMES = ['Homecenter'] as const

export type ManagerMarketplaceStoreName = (typeof MANAGER_MARKETPLACE_STORE_NAMES)[number]

const MARKETPLACE_STORE_FILTER_ROLE_SET = new Set<number>(ROLE_IDS_MARKETPLACE_STORE_FILTER)

/** Roles 17 y 25: listado, filtros y formulario limitados a tiendas marketplace */
export function isManagerMarketplaceRole(roleId: number | undefined | null): boolean {
  return roleId != null && MARKETPLACE_STORE_FILTER_ROLE_SET.has(roleId)
}

function getOrderListStoreRestriction(
  roleId: number | undefined | null
): readonly string[] | null {
  if (roleId === ROLE_ID_OPERACIONES) {
    return OPERACIONES_STORE_NAMES
  }
  if (isManagerMarketplaceRole(roleId)) {
    return MANAGER_MARKETPLACE_STORE_NAMES
  }
  return null
}

function resolveStoresForRoleRestriction(
  allowed: readonly string[],
  requestedStores: string[]
): string[] {
  const allowedSet = new Set<string>(allowed)
  if (requestedStores.length === 0) {
    return [...allowed]
  }
  const filtered = requestedStores.filter((s) => allowedSet.has(s))
  return filtered.length > 0 ? filtered : [...allowed]
}

/** Tiendas permitidas en listado/filtros según rol; null = sin restricción */
export function getOrderListAllowedStoreNames(
  roleId: number | undefined | null
): readonly string[] | null {
  return getOrderListStoreRestriction(roleId)
}

/** Tiendas enviadas al API en GET /list según rol */
export function resolveOrderListStores(
  roleId: number | undefined | null,
  requestedStores: string[]
): string[] {
  const allowed = getOrderListStoreRestriction(roleId)
  if (!allowed) {
    return requestedStores
  }
  return resolveStoresForRoleRestriction(allowed, requestedStores)
}

export function isStoreAllowedForRole(
  roleId: number | undefined | null,
  storeName: string | undefined | null
): boolean {
  if (!storeName?.trim()) return true
  const allowed = getOrderListStoreRestriction(roleId)
  if (!allowed) return true
  return new Set<string>(allowed).has(storeName.trim())
}

export function filterStoreSelectOptions<T extends { value: string; label: string }>(
  roleId: number | undefined | null,
  options: T[]
): T[] {
  const allowed = getOrderListStoreRestriction(roleId)
  if (!allowed) {
    return options
  }
  const allowedSet = new Set<string>(allowed)
  return options.filter((o) => o.value === '' || allowedSet.has(o.value))
}

export function sanitizeStoreFilterValues(
  roleId: number | undefined | null,
  storeValues: string[]
): string[] {
  const allowed = getOrderListStoreRestriction(roleId)
  if (!allowed) {
    return storeValues
  }
  const allowedSet = new Set<string>(allowed)
  return storeValues.filter((s) => allowedSet.has(s))
}
